<template>
  <div v-if="expired" class="center">
    <el-alert type="error" :closable="false">QRCode expirado, gere um novo para realizar o pagameto</el-alert>
    <br />
    <el-button type="success" @click="qrcode(false)">Gerar QRCode</el-button>
  </div>
  <div v-else class="center">
    <img :src="url" />
    <p>
      Expirando em <span v-if="almost" style="color: red">{{ count }}s</span><span v-else>{{ count }}s</span>
    </p>
  </div>
</template>

<script>
import { PaymentService } from "@/services/customers/payment.services";
export default {
  name: 'PaymentFinished',
  props: {
    value: Number,
    billetId: String,
    customer: String,
  },
  computed: {
    almost() {
      return this.count < 30;
    },
    expired() {
      return this.count === 0;
    }
  },
  data() {
    return {
      id: "",
      url: "",
      code: "",
      count: 3600,
    }
  },
  methods: {
    open() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PaymentService.pix({
        value: this.value,
        description: "MaisEnvios - Credito Pix",
        customer: this.customer,
        billetId: this.billetId,
      })
        .then((response) => {
          console.log('response', response)
          vm.url = response.url;
          vm.code = response.qrcode;
          vm.updated();
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        }).finally(() => setTimeout(() => {
          loading.close();
        }, 300))

    },
    updated() {
      this.count = 3600;
      const interval = setInterval(() => {
        this.count--;
        if (this.count <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }
  },
}
</script>
